import { Dispatch, makeActionCreator, RootState } from "../../store/types";
import { Industry, Product } from "../../models";
import { ProjectInfoFormValues } from "./components/ProjectInfoForm";
import { selectors as step1Selectors } from "../Step1";

export const SET_INDUSTRIES = "detailsForm/SET_INDUSTRIES";
export const SET_DATA_LOADING = "detailsForm/SET_DATA_LOADING";
export const TOGGLE_DIMENSION = "detailsForm/TOGGLE_DIMENSION";
export const SET_PROJECT_FORM_VALUES = "detailsForm/SET_PROJECT_FORM_VALUES";
export const RESET = "detailsForm/RESET";
const setDataLoading = makeActionCreator<
  boolean
>(SET_DATA_LOADING as typeof SET_DATA_LOADING);
const setIndustries = makeActionCreator<
  Industry[]
>(SET_INDUSTRIES as typeof SET_INDUSTRIES);
export const toggleDimension = makeActionCreator(
  TOGGLE_DIMENSION as typeof TOGGLE_DIMENSION,
);
export const reset = makeActionCreator(RESET as typeof RESET);

export const setProjectFormValues = makeActionCreator<
  Partial<ProjectInfoFormValues>
>(SET_PROJECT_FORM_VALUES as typeof SET_PROJECT_FORM_VALUES);

// TODO: proper stateful error handling
export const fetchStep4Data = () => async (
  dispatch: Dispatch,
  getState: () => RootState,
  http,
) => {
  dispatch(setDataLoading(true));

  try {
    const product = step1Selectors.chosenProduct(getState()) as Product;

    const dataResponse: any = await http.get(
      `data/products/${product.id}/step4_data`,
    );

    dispatch(setIndustries(dataResponse.industries || []));
  } catch (error) {
    throw error;
  } finally {
    dispatch(setDataLoading(false));
  }
};



// WEBPACK FOOTER //
// ./src/routes/Step4/actions.ts